var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "map-row" },
    [
      _vm._t("default"),
      _c(
        "div",
        { staticClass: "map-col-12" },
        [
          _c(_setup.inputSelect, {
            attrs: {
              items: _setup.items_type,
              label: _setup.$map.trans("map.layer-control.field.type"),
            },
            model: {
              value: _setup.form.type,
              callback: function ($$v) {
                _vm.$set(_setup.form, "type", $$v)
              },
              expression: "form.type",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "map-col-12" },
        [
          _c(_setup.inputFile, {
            attrs: {
              label: _setup.$map.trans("map.layer-control.field.file"),
              accept: ".json,.geojson",
            },
            on: { change: _setup.onChangeFile },
          }),
        ],
        1
      ),
      _setup.geojson_show
        ? _c(
            "div",
            { staticClass: "map-col-12" },
            [
              _c(_setup.inputTextArea, {
                attrs: { value: _setup.geojson_show, rows: "4", readonly: "" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }